import { lensApi } from "@/services/lensApi";

export type StructureProperty = {
	typeId: number;
	value: number;
};

export const addStructureProperties = async (
	structureId: Dryp.StructureId,
	properties: StructureProperty[],
): Promise<void> => {
	return lensApi.post<void>(`/structures/${structureId}/properties`, properties);
};

export const updateStructureProperties = async (
	structureId: Dryp.StructureId,
	properties: StructureProperty[],
): Promise<void> => {
	return lensApi.put<void>(`/structures/${structureId}/properties`, properties);
};
